import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/shadcn/accordion";

/** Microsoft licensing and third-party terms, collapsed so they don't dominate the page. */
export const LicensingNotice = () => (
  <Accordion type="single" collapsible>
    <AccordionItem value="licensing" className="border-none">
      <AccordionTrigger className="py-2 text-sm font-semibold hover:no-underline">
        Licensing and third-party services
      </AccordionTrigger>
      <AccordionContent className="pb-0">
        <div className="space-y-2 text-sm text-muted-foreground">
          <p>
            You and your organisation are responsible for obtaining appropriate licences for all
            use of Microsoft services.
          </p>
          <p>
            You can create and edit content with your user account and if you choose to do so, you
            can share such content between Klipboard CRM and Microsoft services. You agree to be
            solely responsible for the contents of your transmissions through the services and you
            own the content created or stored by you but you grant Klipboard CRM permission to
            transmit the content to Microsoft services for the purpose of providing the selected
            Service to you.
          </p>
          <p>
            We do not warrant or support 3rd party applications even where they may be optionally
            available for use in association with Klipboard CRM. We cannot guarantee the continued
            availability of such features and may cease providing them without entitling you to any
            refund, credit or other compensation, if for example and without limitation, the
            provider ceases to make the application available for interoperation with the
            corresponding service features in a manner acceptable to us.
          </p>
        </div>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
);
